export const BASE_URL = "https://api.essalypos.com/api/v1";